import { Notyf } from 'notyf'
import triangleAlertIcon from 'src/assets/icons/lucide-triangle-alert.svg?raw'

let notifications: (Error | string)[] = []
let notyf: Notyf | null = null

// Duration of 0 means errors persist until manually dismissed
const ERROR_DURATION = 0
// Short dedupe to prevent rapid-fire duplicates from code loops
const ERROR_DEDUPE_TIMEOUT = 2000

if (typeof window !== 'undefined') {
  notyf = new Notyf({
    duration: 5000,
    ripple: false,
    dismissible: true,
    position: {
      x: 'center',
      y: 'top',
    },
    types: [
      {
        type: 'info',
        // background: variables.warning5, TODO: is this a bug?
        icon: false,
      },
      {
        type: 'error',
        duration: ERROR_DURATION,
        icon: triangleAlertIcon,
      },
    ],
  })
}

const dedupeErrors = (error: Error | string, options?: { duration?: number }) => {
  if (!notifications.includes(error)) {
    if (options?.duration !== undefined) {
      // Use open() to pass custom duration that overrides the default
      notyf?.open?.({
        type: 'error',
        message: typeof error === 'string' ? error : error.message,
        duration: options.duration,
      })
    } else {
      notyf?.error?.(error)
    }
    notifications = notifications.concat([error])
    setTimeout(() => {
      notifications = notifications.filter((notification) => notification !== error)
    }, ERROR_DEDUPE_TIMEOUT)
  }
}

export default {
  error: dedupeErrors,
  // @ts-ignore doesn't like the spread params
  success: (...params) => notyf?.success?.(...params),
  // @ts-ignore doesn't like the spread params
  info: (...params) => notyf?.info?.(...params),
  // @ts-ignore doesn't like the spread params
  dismiss: (...params) => notyf?.dismiss?.(...params),
  // @ts-ignore doesn't like the spread params
  dismissAll: (...params) => notyf?.dismissAll?.(...params),
}
